// client/src/components/layout/FinalMessage.jsx
import React, { useState } from 'react';
import { Button, Card } from '../ui/UIComponents';

const FinalMessage = ({ onDismiss, evaluationData }) => {
  const [wantsNewsletter, setWantsNewsletter] = useState(
    evaluationData?.nieuwsbrief?.wants_updates || false
  );
  const [isUpdating, setIsUpdating] = useState(false);

  const handleDismiss = async () => {
    // Check if newsletter preference changed from original evaluation
    const originalPreference = evaluationData?.nieuwsbrief?.wants_updates || false;
    
    if (wantsNewsletter !== originalPreference) {
      setIsUpdating(true);
      try {
        await onDismiss(wantsNewsletter);
      } catch (error) {
        console.error('Error updating newsletter preference:', error);
        setIsUpdating(false);
      }
    } else {
      // No change, just dismiss
      await onDismiss(null);
    }
  };

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-6 z-50 overflow-y-auto">
      <Card className="max-w-3xl my-8">
        <div className="text-center mb-6">
          <div className="text-6xl mb-4">🎉</div>
          <h1 className="text-3xl font-bold text-gray-800 mb-4">
            Gefeliciteerd!
          </h1>
          <h2 className="text-xl text-gray-700 mb-6">
            Je hebt de training Motiverende Gespreksvoering afgerond!
          </h2>
        </div>

        <div className="prose prose-lg max-w-none mb-8 text-left">
          <p className="text-gray-700 leading-relaxed mb-4">
            In deze cursus heb je geoefend met:
          </p>
          
          <ul className="list-none ml-0 mb-6">
            <li className="text-gray-700 mb-3">
              <strong>het herkennen en versterken van verandertaal</strong> door:
              <ul className="list-disc ml-6 mt-2 space-y-1">
                <li>het stellen van open vragen</li>
                <li>reflectief luisteren</li>
              </ul>
            </li>
          </ul>

          <p className="text-gray-700 leading-relaxed mb-4">
            Deze technieken vormen maar een klein stukje van het geheel van processen, 
            waarden en technieken wat motiverende gesprekvoering te bieden heeft. Toch 
            denken wij dat je nu al een <strong>bruikbare set aan vaardigheden</strong> in 
            huis hebt om met meer zekerheid motiverende gesprekvoering in de praktijk te 
            gaan toepassen.
          </p>

          <p className="text-gray-700 leading-relaxed mb-4">
            We hopen in de toekomst meer online trainingen te gaan aanbieden zodat je ook 
            met de andere aspecten kan gaan oefenen.
          </p>

          <p className="text-gray-700 leading-relaxed mb-4">
            Wil je op de hoogte gehouden worden wanneer er een nieuwe training beschikbaar is? 
            Schrijf je in voor de maillijst voor korting op toekomstige trainingen.
          </p>
        </div>

        {/* Newsletter checkbox */}
        <div className="my-6 p-4 bg-blue-50 rounded-lg border-2 border-blue-200">
          <label className="flex items-start space-x-3 cursor-pointer">
            <input
              type="checkbox"
              checked={wantsNewsletter}
              onChange={(e) => setWantsNewsletter(e.target.checked)}
              className="w-5 h-5 text-blue-600 mt-1 rounded"
            />
            <span className="text-gray-700 leading-relaxed">
              <strong>Ja, ik wil op de hoogte worden gehouden</strong> wanneer er nieuwe trainingen 
              beschikbaar zijn van LerenMotiveren voor korting op toekomstige trainingen.
            </span>
          </label>
        </div>

        <div className="flex flex-col space-y-3">
          <Button 
            onClick={handleDismiss} 
            size="lg" 
            className="w-full"
            disabled={isUpdating}
          >
            {isUpdating ? 'Opslaan...' : 'Terug naar Dashboard'}
          </Button>
          
          {/* Optional: Download certificate button - can be implemented later */}
          {/* <Button variant="outline" size="lg" className="w-full">
            📄 Download Certificaat
          </Button> */}
        </div>
      </Card>
    </div>
  );
};

export default FinalMessage;